import CryptoJS from 'crypto-js';
const ENCRYPTION_TYPE = { ENCRYPT: 1, DECRYPT: 2 };
const Encrypt = (object) =>
  Object.getOwnPropertyNames(object)?.length === 0
    ? {}
    : CryptoJS.AES.encrypt(
        JSON.stringify(object),
        process.env.REACT_APP_ENCRYPTION_KEY,
      )?.toString();

const Decrypt = (object) =>
  Object.getOwnPropertyNames(object)?.length === 0
    ? {}
    : JSON.parse(
        CryptoJS.AES.decrypt(object, process.env.REACT_APP_ENCRYPTION_KEY)?.toString(
          CryptoJS.enc.Utf8,
        ),
      );

const EncryptDecrypt = (object, type) => {
  if (!object) {
    return {};
  }
  if (type === ENCRYPTION_TYPE.ENCRYPT) {
    return Encrypt(object);
  } else {
    return Decrypt(object);
  }
};

export { EncryptDecrypt, ENCRYPTION_TYPE };
